import React, { useMemo, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AppShell from "../common/AppShell";
import API from "../../api/api";

export default function ConsumerShell({ children, hideHeader, edgeToEdge }) {
  const navigate = useNavigate();
  const location = useLocation();

  const loginContext = useMemo(() => {
    try {
      return String(localStorage.getItem("login_context_user") || sessionStorage.getItem("login_context_user") || "").toLowerCase();
    } catch {
      return "";
    }
  }, []);
  const isTeamLogin = loginContext === "team";

  const [currentUser, setCurrentUser] = useState(() => {
    try {
      const ls = localStorage.getItem("user_user") || sessionStorage.getItem("user_user");
      return ls ? JSON.parse(ls) : {};
    } catch {
      return {};
    }
  });

  // Listen for user updates dispatched across the app
  useEffect(() => {
    const handleUserUpdate = (e) => {
      if (e?.detail) setCurrentUser(e.detail);
    };
    window.addEventListener("trikonekt:user-updated", handleUserUpdate);
    return () => window.removeEventListener("trikonekt:user-updated", handleUserUpdate);
  }, []);

  // Fetch live profile in background if tier_badge or achieved_level is missing
  useEffect(() => {
    let alive = true;
    if (!currentUser?.tier_badge && !currentUser?.achieved_level) {
      API.get("/accounts/profile/", { cacheTTL: 15000 })
        .then((res) => {
          if (!alive || !res?.data) return;
          const merged = { ...currentUser, ...res.data };
          setCurrentUser(merged);
          try {
            localStorage.setItem("user_user", JSON.stringify(merged));
            if (res.data.tier_badge) {
              localStorage.setItem("tri_user_tier_badge", res.data.tier_badge);
            }
          } catch (_) {}
        })
        .catch(() => {});
    }
    return () => {
      alive = false;
    };
  }, []);

  const onLogout = () => {
    try {
      localStorage.removeItem("token_user");
      localStorage.removeItem("refresh_user");
      localStorage.removeItem("role_user");
      localStorage.removeItem("user_user");
      sessionStorage.removeItem("token_user");
      sessionStorage.removeItem("refresh_user");
      sessionStorage.removeItem("role_user");
      sessionStorage.removeItem("user_user");
    } catch (_) {}
    navigate("/", { replace: true });
  };

  const title = useMemo(() => {
    const path = location.pathname;
    if (path.includes("/team-dashboard") || path.includes("/user/dashboard")) return "Community Consumer";
    if (path.includes("/wallet") || path.includes("/withdrawal")) return "Wallet";
    if (path.includes("/spp")) return "Smart Product Purchase";
    if (path.includes("/coupon-pocket")) return "Coupon Pocket";
    if (path.includes("/upload-wallet")) return "Add Money";
    if (path.includes("/digital-education")) return "Digital Education";
    if (path.includes("/educational-videos")) return "Educational Videos";
    if (path.includes("/genealogy")) return "Layer Blocks";
    if (path.includes("/profile")) return "Profile";
    if (path.includes("/kyc")) return "KYC Verification";
    if (path.includes("/history")) return "Transaction History";
    return isTeamLogin ? "Community Consumer" : "Consumer";
  }, [location.pathname, isTeamLogin]);

  return (
    <AppShell
      title={title}
      user={currentUser}
      onLogout={onLogout}
      isTeam={isTeamLogin}
      rootPaths={["/user/team-dashboard", "/user/dashboard", "/v4/home"]}
      onBackFallbackPath={isTeamLogin ? "/user/team-dashboard" : "/user/dashboard"}
      hideHeader={hideHeader}
      edgeToEdge={edgeToEdge}
    >
      {children}
    </AppShell>
  );
}
